export const buildInitialCheckoutState = (overrides) => ({
  duration: 'yearly',
  checkout_submitting: false,
  checkout_success: false,
  checkout_error: null,
  hideTerms: false,
  isStudentPromotion: false,
  isTrial: false,
  promo_code_submitting: false,
  promo_code_error: false,
  promo_code_input_visibility: false,
  products: null,
  ...overrides
});

export default { buildInitialCheckoutState };
